import { colors } from 'constants/colors';
import { WLabel } from 'constants/enums';
import { defaultTheme, FontFamily } from 'theme';
import { selectByWL } from 'utils/wLabel';
import { buttonThemeStyles } from '../ThemedButton/themes';
import { FontWeight, FontSize } from 'theme';
import defaultProductPicGlobus from 'assets/images/globus/defaultProductPicGlobus.svg';

enum PriceSizes {
  big = 'big',
  medium = 'medium',
}

enum PriceTypes {
  old = 'old',
  main = 'main',
  fract = 'fract',
  sale = 'sale',
  end = 'end',
}

/* Старые темы для AddToOrderModal */
export const oldQuantityThemeStyles = {
  [WLabel.Default]: {
    bgColor: colors.grederlevyLightTwo,
    color: colors.darkBlueGreen,
    borderColor: colors.darkBlueGreen,
    hover: {
      bgColor: colors.darkBlueGreen,
      color: colors.white,
    },
    borderRadius: 12,
    fontSize: FontSize.l,
    fontWeight: FontWeight.semiBold,
  },
  [WLabel.Globus]: {
    bgColor: colors.white,
    color: colors.simpleOrange,
    borderColor: colors.simpleOrange,
    hover: {
      bgColor: colors.simpleOrange,
      color: colors.white,
    },
    borderRadius: 25,
    fontSize: FontSize.l,
    fontWeight: FontWeight.extraBold,
  },
};

export const quantityThemeStyles = {
  [WLabel.Default]: {
    fontSize: FontSize.xs,
    fontWeight: FontWeight.semiBold,
    fontFamily: FontFamily.secondFont,
  },
  [WLabel.Globus]: {
    color: colors.simpleOrange,
    bgColor: colors.white,
    borderColor: colors.brightOrange,
    fontSize: FontSize.xs,
    fontWeight: FontWeight.semiBold,
    fontFamily: FontFamily.secondFont,
    hover: {
      color: colors.white,
      bgColor: colors.simpleOrange,
      borderColor: colors.simpleOrange,
    },
  },
};

export const quantityThemeStylesWithLimit = {
  [WLabel.Default]: {
    fontSize: FontSize.xs,
    fontWeight: FontWeight.semiBold,
    fontFamily: FontFamily.secondFont,
    color: colors.darkPink,
    bgColor: colors.almostWhite,
    borderColor: colors.greyishTwo,
    hover: {
      bgColor: colors.almostWhite,
      borderColor: colors.greyishTwo,
    },
  },
  [WLabel.Globus]: {
    fontSize: FontSize.xs,
    fontWeight: FontWeight.semiBold,
    fontFamily: FontFamily.secondFont,
    color: colors.darkPink,
    bgColor: colors.almostWhite,
    borderColor: colors.greyishTwo,
    hover: {
      bgColor: colors.almostWhite,
      borderColor: colors.greyishTwo,
    },
  },
};

export const productThemeStyles = {
  [WLabel.Default]: {
    typography: {
      ...defaultTheme.typography,
      [FontSize.xs]: { fontSize: '11px', lineHeight: '18px' },
      [FontSize.s]: { fontSize: '14px', lineHeight: '18px' },
      [FontSize.l]: { fontSize: '18px', lineHeight: '26px' },
      [FontSize.xl]: { fontSize: '22px', lineHeight: '30px' },
    },
    typographyMobile: {
      ...defaultTheme.typographyMobile,
      [FontSize.xs]: { fontSize: '10px', lineHeight: '12px' },
      [FontSize.s]: { fontSize: '13px', lineHeight: '16px' },
      [FontSize.l]: { fontSize: '14px', lineHeight: '16px' },
      [FontSize.xl]: { fontSize: '22px', lineHeight: '30px' },
    },
    borderRadius: 0,
  },
  [WLabel.Globus]: {
    typography: {
      ...defaultTheme.typography,
      [FontSize.xs]: { fontSize: '14px', lineHeight: '16px' },
      [FontSize.s]: { fontSize: '16px', lineHeight: '18px' },
      [FontSize.l]: { fontSize: '18px', lineHeight: '26px' },
      [FontSize.xl]: { fontSize: '24px', lineHeight: '30px' },
    },
    typographyMobile: {
      ...defaultTheme.typographyMobile,
      [FontSize.xs]: { fontSize: '12px', lineHeight: '12px' },
      [FontSize.s]: { fontSize: '14px', lineHeight: '16px' },
      [FontSize.l]: { fontSize: '16px', lineHeight: '16px' },
      [FontSize.xl]: { fontSize: '24px', lineHeight: '30px' },
    },
    order: {
      button: buttonThemeStyles[WLabel.Globus].secondary,
    },
    quantity: oldQuantityThemeStyles[WLabel.Globus],
    basket: {
      button: buttonThemeStyles[WLabel.Globus].main,
    },
    defaultProductPic: defaultProductPicGlobus,
    addToBasketText: 'Купить',
    priceSign: 'руб.',
    comment: {
      field: {
        bgColor: colors.white,
        fontWeight: FontWeight.semiBold,
      },
      btn: {
        borderRadius: 6,
        width: '24px',
        height: '24px',
        bgColor: colors.simpleLightOrange,
        hoverBgColor: colors.simpleLightOrange,
        bgColorDesktop: colors.simpleLightOrange,
        icon: {
          width: '12',
          height: '12',
          defaultColor: colors.darkGreyTwo,
          defaultColorDesktop: colors.darkGreyTwo,
        },
      },
      mobileBtn: {
        borderRadius: 0,
        width: '112px',
        height: '100%',
        bgColor: colors.simpleOrange,
      },
    },
    remove: {
      bgColor: colors.white,
      activeBgColor: colors.simpleLightOrange,
      icon: {
        defaultColor: colors.pinkishGrey,
        activeColor: colors.black,
      },
      mobileBtn: {
        borderRadius: 0,
        width: '112px',
        height: '100%',
        bgColor: colors.sizzlingRed,
      },
    },
    price: {
      [PriceTypes.old]: {
        size: {
          [PriceSizes.big]: { fontSize: FontSize.xs },
          [PriceSizes.medium]: { fontSize: FontSize.xs },
        },
        color: colors.warmGrey,
        fontWeight: FontWeight.extraBold,
      },
      [PriceTypes.main]: {
        size: {
          [PriceSizes.big]: { fontSize: FontSize.xl },
          [PriceSizes.medium]: { fontSize: FontSize.m },
        },
        fontWeight: FontWeight.extraBold,
      },
      [PriceTypes.end]: {
        size: {
          [PriceSizes.big]: { fontSize: FontSize.xl },
          [PriceSizes.medium]: { fontSize: FontSize.s },
        },
        fontWeight: FontWeight.extraBold,
      },
      [PriceTypes.fract]: {
        size: {
          [PriceSizes.big]: { fontSize: FontSize.s },
          [PriceSizes.medium]: { fontSize: FontSize.s },
        },
        fontWeight: FontWeight.extraBold,
      },
      [PriceTypes.sale]: {
        color: colors.brightRed,
      },
    },
    name: {
      fontWeight: FontWeight.semiBold,
    },
    quantityText: {
      fontWeight: FontWeight.semiBold,
    },
    label: {
      fontWeight: FontWeight.semiBold,
    },
    alwaysShowAddToCard: true,
  },
};

export const themeCardByWL = {
  ...defaultTheme,

  button: selectByWL(buttonThemeStyles).main,
  ...selectByWL(productThemeStyles),
  /* Временно переписываем стили вовода количества только для сетки */
  quantity: selectByWL(quantityThemeStyles),
};

export const themeCardByWLWithLimit = {
  ...defaultTheme,
  ...selectByWL(productThemeStyles),
  quantity: selectByWL(quantityThemeStylesWithLimit),
};

export const themeListCardByWL = {
  ...defaultTheme,
  typography: {
    ...defaultTheme.typography,
    300: { fontSize: '14px', lineHeight: '18px' },
    400: { fontSize: '16px', lineHeight: '18px' },
    500: { fontSize: '18px', lineHeight: '26px' },
    600: { fontSize: '22px', lineHeight: '26px' },
  },
  typographyMobile: {
    ...defaultTheme.typographyMobile,
    200: { fontSize: '12px', lineHeight: '16px' },
    300: { fontSize: '12px', lineHeight: '16px' },
    500: { fontSize: '14px', lineHeight: '16px' },
    600: { fontSize: '18px', lineHeight: '24px' },
  },
  button: { ...selectByWL(buttonThemeStyles).main, height: { small: 32, normal: 40, large: 50 } },
  ...selectByWL(productThemeStyles),
};
